module.exports = __webpack_public_path__ + "img/1534406483.398ca174.jpg";